export interface ConnectInstagramAccountDto {
  code: string;
  redirectUri: string;
}

export interface InstagramAccount {
  _id: string;
  user: string;
  appScopedId: string;
  instagramId: string;
  username: string;
  permissions: InstagramAccountPermission[];
  accessRevokedDate?: number;
}

export enum InstagramAccountPermission {
  INSTAGRAM_BUSINESS_BASIC = 'instagram_business_basic',
  INSTAGRAM_BUSINESS_MANAGE_MESSAGES = 'instagram_business_manage_messages'
}

export enum InstagramAccountHighLevelPermissionType {
  MESSAGING = 'messaging'
}

export interface InstagramAuthUrl {
  url: string;
}
